import React, { useState, useEffect } from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const Testimonials = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const testimonials = [
        {
            name: "Ahmed Al-Sayed",
            age: 18,
            course: "A-Level Maths & Physics",
            school: "British School of Bahrain",
            result: "Offer from Imperial College London",
            quote: "The structured approach to A-Levels was exactly what I needed. My tutor understood the British curriculum perfectly and helped me bridge the gap. I went from predicting B's to achieving A*'s.",
            metrics: {
                timeToCompletion: "4 months",
                gradeImprovement: "B to A*",
                quizAccuracy: "96%"
            },
            avatar: "👨‍🎓",
            rating: 5
        },
        {
            name: "Fatima Hassan",
            age: 16,
            course: "IGCSE Bundle",
            school: "Dubai English Speaking College",
            result: "9s in all Sciences",
            quote: "I was struggling with the volume of content for my IGCSEs. Synapse tutors made it manageable. The flexible online sessions meant I could study from home in Dubai with top UK tutors.",
            metrics: {
                timeToCompletion: "6 months",
                gradeImprovement: "6 to 9",
                quizAccuracy: "94%"
            },
            avatar: "🧕",
            rating: 5
        },
        {
            name: "Omar Khalid",
            age: 17,
            course: "A-Level Economics",
            school: "Riyadh Schools",
            result: "Top in Class",
            quote: "Finding high-quality British curriculum tutoring in Riyadh was hard until I found Synapse. The 1-on-1 attention and expert feedback on my essays were game-changers for my Economics grade.",
            metrics: {
                timeToCompletion: "3 months",
                gradeImprovement: "C to A",
                quizAccuracy: "91%"
            },
            avatar: "🧑‍💻",
            rating: 5
        },
        {
            name: "Layla Mahmoud",
            age: 19,
            course: "University Prep",
            school: "Cairo English School",
            result: "Accepted to UCL",
            quote: "The university application support was incredible. My personal statement needed work, and the mock interviews gave me the confidence I needed to succeed. Highly recommended for anyone applying to the UK.",
            metrics: {
                timeToCompletion: "8 weeks",
                gradeImprovement: "Successful Entry",
                quizAccuracy: "100%"
            },
            avatar: "👩‍🎓",
            rating: 5
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % testimonials.length);
        }, 5000); // Auto-advance every 5 seconds

        return () => clearInterval(interval);
    }, [testimonials.length]);

    return (
        <section id="testimonials" className="section">
            <div className="section-header">
                <h2 className="section-title">
                    What Our <span className="highlight-yellow">Students</span> Say
                </h2>
                <p className="section-subtitle">
                    Real results from real students. See how we've helped thousands achieve their academic goals.
                </p>
            </div>

            <div className="testimonials-slider">
                <div className="testimonials-track">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={currentIndex}
                            className="testimonial-card-slider"
                            initial={{ opacity: 0, x: 300 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -300 }}
                            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                        >
                            <div className="testimonial-header">
                                <div className="testimonial-avatar">{testimonials[currentIndex].avatar}</div>
                                <div className="testimonial-info">
                                    <div className="testimonial-name">{testimonials[currentIndex].name}</div>
                                    <div className="testimonial-details">
                                        {testimonials[currentIndex].age} • {testimonials[currentIndex].course}
                                    </div>
                                    <div className="testimonial-school">{testimonials[currentIndex].school}</div>
                                </div>
                            </div>

                            <div className="testimonial-stars">
                                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                                    <FaStar key={i} />
                                ))}
                            </div>

                            <div className="testimonial-quote-wrapper">
                                <FaQuoteLeft className="quote-icon" />
                                <p className="testimonial-quote">{testimonials[currentIndex].quote}</p>
                            </div>

                            <div className="testimonial-metrics">
                                <div className="metric-item">
                                    <span className="metric-label">Time:</span>
                                    <span className="metric-value">{testimonials[currentIndex].metrics.timeToCompletion}</span>
                                </div>
                                <div className="metric-item">
                                    <span className="metric-label">Improvement:</span>
                                    <span className="metric-value">{testimonials[currentIndex].metrics.gradeImprovement}</span>
                                </div>
                                <div className="metric-item">
                                    <span className="metric-label">Accuracy:</span>
                                    <span className="metric-value">{testimonials[currentIndex].metrics.quizAccuracy}</span>
                                </div>
                            </div>

                            <div className="testimonial-result">
                                {testimonials[currentIndex].result}
                            </div>
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>

            <div className="testimonial-indicators">
                {testimonials.map((_, index) => (
                    <div
                        key={index}
                        className={`testimonial-indicator ${index === currentIndex ? 'active' : ''}`}
                    />
                ))}
            </div>
        </section>
    );
};

export default Testimonials;
